import { render, staticRenderFns } from "./PlanNoteForm.vue?vue&type=template&id=3a3d486c&lang=pug"
import script from "./PlanNoteForm.vue?vue&type=script&lang=js"
export * from "./PlanNoteForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PlanNotesPlanPicker: require('/home/docker/code/frontend/components/plan-notes/PlanNotesPlanPicker.vue').default})
